"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "MissionControl___StyledSvg",
  componentId: "sc-15cq9r9-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function MissionControl(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M404.102 403.989c-2.942 2.962-8.782 3.575-13.162 3.575-24.145 0-67.377-19.146-117.339-55.492 28.97-25.09 54.067-50.245 78.698-78.784 15.173 20.754 27.997 41.106 37.561 60.23 22.346 44.66 19.088 65.626 14.242 70.47M88.06 407.565c-4.38 0-10.2-.613-13.162-3.575-4.846-4.845-8.083-25.81 14.242-70.47 9.564-19.125 22.388-39.477 37.582-60.231 24.61 28.518 49.686 53.672 78.677 78.784-49.94 36.346-93.194 55.492-117.339 55.492M74.898 74.866c2.963-2.92 8.782-3.554 13.162-3.554 24.145 0 67.399 19.146 117.339 55.492-28.462 24.668-53.982 50.118-78.804 78.848C76.358 136.98 63.662 86.142 74.898 74.866m250.76 164.636a744.51 744.51 0 01-41.265 44.829c-15.151 15.148-30.133 28.455-44.882 40.873-14.77-12.418-29.753-25.725-44.883-40.873-15.427-15.423-29.012-30.38-41.264-44.83 12.739-15.084 26.472-30.168 41.264-44.935 15.13-15.147 30.112-28.497 44.883-40.915 14.749 12.418 29.731 25.768 44.882 40.915 14.77 14.767 28.504 29.851 41.265 44.936m65.282-168.19c4.38 0 10.22.635 13.162 3.554 11.236 11.276-1.44 62.114-51.676 130.786-24.843-28.73-50.342-54.18-78.825-78.848 49.962-36.346 93.194-55.492 117.339-55.492zM239.5 197.35c23.24 0 42.1 18.856 42.1 42.088s-18.86 42.088-42.1 42.088c-23.24 0-42.1-18.856-42.1-42.088s18.86-42.088 42.1-42.088zm188.218 117.234c-11.978-23.927-28.272-49.42-47.846-75.21 59.273-78.17 91.162-157.42 54.152-194.422C426.744 37.695 413.349 29 390.94 29c-38.514 0-93.596 26.17-151.43 70.068C181.657 55.17 126.575 29 88.06 29c-22.41 0-35.783 8.695-43.084 15.952-36.99 37.001-5.12 116.251 54.173 194.423-19.574 25.789-35.89 51.282-47.867 75.209-34.62 69.243-22.536 103.093-6.306 119.32 7.301 7.298 20.675 15.972 43.084 15.972 38.514 0 93.596-26.149 151.45-70.09 57.834 43.941 112.916 70.09 151.43 70.09 22.41 0 35.804-8.674 43.084-15.973 16.23-16.226 28.313-50.076-6.306-119.32"
  }));
}

var _default = MissionControl;
exports["default"] = _default;